import {Component, inject, OnInit, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {MemberService} from '@services/member.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {MemberCardComponent} from '@components/member-card/member-card.component';
import {AsyncPipe, NgClass} from '@angular/common';
import {AchievementService} from '@services/achievement.service';
import {AchievementRowComponent} from '@components/achievement-row/achievement-row.component';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';
import {MatchService} from '@services/match.service';
import {Title} from '@angular/platform-browser';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {ActiveMemberCardComponent} from '@components/active-member-card/active-member-card.component';
import {environment} from '@/environments/environment';
import {SeparatorComponent, TitleComponent} from '@/app/shared';
import {MemberTiny} from '@/app/core/models/member';
import {Achievement} from '@/app/core/models/achievement';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';
import {FaceItLeaderboard, FaceitService} from '@services/faceit.service';

@Component({
  selector: 'app-roster-overwatch-pro',
	imports: [
		SeparatorComponent,
		MemberCardComponent,
		AsyncPipe,
		AchievementRowComponent,
		UpcomingMatchsComponent,
		TitleComponent,
		TranslatePipe,
		LastVideosComponent,
		ActiveMemberCardComponent,
		NgClass,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './roster-overwatch-pro.component.html',
})
export class RosterOverwatchProComponent implements OnInit {

	private readonly memberService = inject(MemberService);
	private readonly achievementService = inject(AchievementService);
	private readonly matchService = inject(MatchService);
	private readonly titleService = inject(Title);
	private readonly faceitService = inject(FaceitService);

	minioBaseUrl: string = environment.minioBaseUrl;

	private readonly membersSubject = new BehaviorSubject<MemberTiny[]>([]);
	private readonly coachesSubstitutesSubject = new BehaviorSubject<MemberTiny[]>([]);

	members$: Observable<MemberTiny[]> = this.membersSubject.asObservable();
	coachesSubstitutes$: Observable<MemberTiny[]> = this.coachesSubstitutesSubject.asObservable();

	achievements: Achievement[] = [];
	matches: CalendarGroupByDate[] = [];
	faceItleaderboard: WritableSignal<FaceItLeaderboard[]> = signal([]);


	ngOnInit(): void {
		this.loadMembers();
		this.loadAchievements();
		this.loadMatches();
		this.loadLeaderboard();
	}

	loadMembers() {
		this.memberService.getActiveMembers('OVERWATCH_PRO').subscribe({
			next: (members) => {
				this.membersSubject.next(members['members']);
				this.coachesSubstitutesSubject.next([
					...members['substitutes'],
					...members['coaches']
				]);
			},
			error: (error) => {
				console.error('Error fetching members:', error);
			}
		});
	}

	loadAchievements() {
		this.achievementService.getAllAchievementByRosterType('OVERWATCH_PRO').subscribe({
			next: (achievements) => {
				this.achievements = achievements;
			},
			error: (error) => {
				console.error('Error fetching achievements:', error);
			}
		})
	}

	loadMatches() {
		this.matchService.getUpcomingMatchesByEventType('OVERWATCH_PRO').subscribe({
			next: (matches) => {
				this.matches = matches;
			},
			error: (error) => {
				console.error('Error fetching matches:', error);
			}
		})
	}

	private loadLeaderboard() {
		this.faceitService.getLeaderboard().subscribe({
			next: (leaderboard) => {
				this.faceItleaderboard.set(leaderboard);
			},
			error: (error) => {
				console.error('Error fetching leaderboard:', error);
			}
		});
	}
}
